export default __webpack_public_path__ + "static/media/gas_package.bf741b15.png";